import React from "react";
import { observer } from "mobx-react-lite";
import { Outlet, ScrollRestoration } from "react-router-dom";

import { useInterceptors } from "../hooks";

const PublicRoute: React.FC = observer(() => {
	useInterceptors();

	return <>
		<Outlet />
		<ScrollRestoration />
	</>;
});

export default PublicRoute;
